import { FaEye } from "react-icons/fa";

export const Proj4 = () => {
  return (
    <article className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-500 bg-white/5 backdrop-blur-sm mt-4">
      {/* Project Image */}
      <img src="/img/projects/adriver.png" alt="aDrive E-hailing Drivers" className="w-full h-64 md:h-72 object-cover rounded-t-2xl" loading="lazy" />

      {/* Project Info */}
      <div className="p-6 space-y-4">
        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">aDrive E-hailing Drivers</h3>
        <p className="text-gray-600 text-lg leading-relaxed">The aDrive Drivers app enables drivers to receive ride requests, navigate efficiently, and manage earnings with ease. It provides real-time trip updates, secure payments, and performance insights to enhance the driving experience.</p>
        <div className="flex justify-center mt-4">
          <a href="https://play.google.com/store/apps/details?id=com.adrive.adrive_driver" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:scale-105 transition-transform duration-300" aria-label="View aDrive E-hailing Drivers app">
            <FaEye className="mr-2" /> View
          </a>
        </div>
      </div>
    </article>
  );
};
